export const WEBSITE_CONTENT = "WEBSITE_CONTENT";
export const COMPANY_DATA = "COMPANY_DATA";
export const MENU_LIST_DATA = "MENU_LIST_DATA";
export const BLOG_LIST_DATA = "BLOG_LIST_DATA";
export const WEBSITE_LOADING = "WEBSITE_LOADING";
export const SEO_META_DATA = "SEO_META_DATA";
export const CATEGORY_DATA = "CATEGORY_DATA";
